import { UseQueryOptions, useMutation, useQuery } from '@tanstack/react-query';
import { HTTPError } from 'ky';

import { queryClient } from '@/adapters/query';
import { usersv2Client } from '@/adapters/schemaClients';
import {
  OrganizationMfaSettings,
  UpdateOrganizationMfaSettingsRequest
} from '@/types/users';

export const ORG_MFA_SETTINGS_QUERY_KEY = 'organizationMfaSettings';

const invalidateOrgMfaSettingsQuery = () => {
  queryClient.invalidateQueries([ORG_MFA_SETTINGS_QUERY_KEY]);
};

const useFindOrgMfaSettingsQuery = (
  options: UseQueryOptions<OrganizationMfaSettings, HTTPError> = {}
) =>
  useQuery<OrganizationMfaSettings, HTTPError>(
    [ORG_MFA_SETTINGS_QUERY_KEY],
    async () => {
      const response = await usersv2Client.getOrganizationMfaSettings();
      return response.data!;
    },
    {
      staleTime: 60_000,
      ...options
    }
  );

export const useOrgMfaSettingsQuery = () => {
  // UPDATE MUTATION
  const updateOrgMfaSettingsMutation = useMutation(
    (payload: UpdateOrganizationMfaSettingsRequest) =>
      usersv2Client.updateOrganizationMfaSettings({
        updateOrganizationMfaSettingsRequest: payload
      }),
    {
      onSuccess: invalidateOrgMfaSettingsQuery
    }
  );

  return {
    invalidate: invalidateOrgMfaSettingsQuery,
    useFind: useFindOrgMfaSettingsQuery,
    mutations: {
      update: updateOrgMfaSettingsMutation
    }
  };
};
